<template>
  <div class="extra-style-upload">
    <pages-wrapper>
      <div class="image-wrapper">
        <img :src="getTemplate">
        <div class="image-uploader-wrapper">
          <van-uploader
            ref="uploader"
            :after-read="afterRead"
            v-model="fileList"
            :max-count="1"
            upload-text="上传图片">
          </van-uploader>
        </div>
      </div>
    </pages-wrapper>
    <div class="confirm-btn">
      <img src="../../assets/images/extra-style/confirm.png" @click="hanldeConfirmUpload">
    </div>

    <div v-show="showCropper" class="cropper-content">
      <div class="cropper">
        <vue-cropper
          ref="cropper"
          fixed
          :fixedNumber="[0.75, 1]"
          :img="imgBase64"
          :autoCrop="true"
          :centerBox="true"
          :full="true"
          :infoTrue="true"
          :maxImgSize="3000"
          >
        </vue-cropper>
      </div>
      <div class="cropper-button">
        <van-button type="info" size="small" @click="handleCancelCropper">取消</van-button>
      </div>
      <div class="cropper-button">
        <van-button type="primary" size="small" @click="handleConfirmCropper">确认</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import PagesWrapper from './components/pages-wrapper'
import Compress from 'compress.js'
import { VueCropper } from 'vue-cropper'
import extraStyleApi from '@/api/extra-style'
import fileApi from '@/api/file'
import { userUtils } from '@/utils/auth'
export default {
  name: 'ExtraStyleUploadImage',
  components: {
    PagesWrapper,
    VueCropper
  },
  computed: {
    getTemplate () {
      const url = require('../../assets/images/extra-style/' + this.$route.query.templateCode + '.png')
      return url
    }
  },
  watch: {
    fileList () {
      if (this.fileList.length === 0) {
        this.imgBase64 = ''
      }
    }
  },
  created () {
    this.queryPhotoList()
    this.templateCode = this.$route.query.templateCode
    this.photoMonth = this.templateCode.slice(0, this.templateCode.indexOf('-'))
  },
  data () {
    return {
      photoList: [],
      fileList: [],
      imgBase64: '',
      imgWidth: '',
      imgHeight: '',
      showCropper: false,
      photoFileId: '',
      templateCode: '',
      photoMonth: '',
      photoYear: ''
    }
  },
  methods: {
    // 查询图片列表
    queryPhotoList () {
      this.userInfo = userUtils.getClientInfo()
      const params = {
        clientId: this.userInfo ? this.userInfo.clientId : ''
      }
      extraStyleApi.queryExtraStylePhotoList(params).then((response) => {
        if (response.data.resultCode === '0') {
          this.photoList = response.data.resultData.photoList || []
        }
      })
    },
    afterRead (file) {
      if (file.file.size < 3 * 1024 * 1024) {
        this.imgBase64 = file.content
        this.showCropper = true
      } else {
        this.fileList = []
        this.handleOversize(file)
      }
    },
    getImageWH (file) {
      return new Promise(resolve => {
        const image = new Image()
        image.onload = () => {
          this.imgWidth = image.width
          this.imgHeight = image.height
          // this.$refs.cropper.cropW = this.imgWidth
          // this.$refs.cropper.cropH = this.imgHeight
          // console.log('width', image.width)
          // console.log('height', image.height)
          resolve()
        }
        image.src = file.content
      })
    },
    handleOversize (file) {
      this.imgBase64 = file.content
      this.getImageWH(file).then(() => {
        this.$toast.loading({
          duration: 0,
          forbidClick: true,
          mask: true,
          message: '加载中，请稍后'
        })
        console.log('开始压缩')
        const compress = new Compress()
        const files = [file.file]
        compress.compress(files, {
          quality: 0.5,
          // maxWidth: (this.imgWidth / 2),
          // maxHeight: (this.imgHeight / 2),
          resize: false
        }).then((data) => {
          const fileBlob = Compress.convertBase64ToFile(data[0].data, data[0].ext)
          const compressFile = {
            content: `${data[0].prefix}${data[0].data}`,
            file: fileBlob
          }
          this.imgBase64 = `${data[0].prefix}${data[0].data}`
          this.fileList.push(compressFile)
        }).then(() => {
          this.$toast.clear()
          this.showCropper = true
        })
      })
    },
    // 取消截图
    handleCancelCropper () {
      this.showCropper = false
      this.fileList = []
    },
    // 开始截图
    handleConfirmCropper () {
      this.showCropper = true
      // console.log(this.fileList[0])
      this.$refs.cropper.startCrop()
      new Promise(resolve => {
        this.$refs.cropper.getCropBlob((data) => {
          this.fileList[0].file = data
          resolve()
        })
      }).then(() => {
        this.$refs.cropper.getCropData((data) => {
          this.fileList[0].content = data
        })
      }).then(() => {
        this.showCropper = false
      })
    },
    // 上传图片
    hanldeConfirmUpload () {
      const acticityTime = this.checkedActivityTime()
      console.log('acticityTime', acticityTime)
      if (!acticityTime) return
      if (this.fileList.length === 0) {
        this.$notify({ type: 'warning', message: '请上传图片' })
        return
      }
      // const currentMonth = new Date().getMonth() + 1
      let repeatImage = false
      this.photoList.forEach(item => {
        if (item.photoMonth.toString() === this.photoMonth) {
          repeatImage = true
        }
      })
      if (repeatImage) {
        this.$dialog.confirm({
          title: '提示',
          message: '继续上传将会覆盖当月照片，是否继续？'
        }).then(() => {
          console.log('succuss')
          // on confirm
          this.getPhotoId()
        }).catch(() => {
          // on cancel
          console.log('false')
        })
      } else {
        this.getPhotoId()
      }
    },
    // 获取图片id
    getPhotoId () {
      return new Promise((resolve, reject) => {
        this.$toast.loading({
          duration: 0,
          forbidClick: true,
          mask: true,
          message: '上传图片'
        })
        fileApi.uploadFilePublic(this.fileList[0].file).then(response => {
          this.$toast.clear()
          if (response.data.resultCode === '0') {
            const photoFileId = response.data.resultData.fileDTO.fileId
            this.uploadPhoto(photoFileId)
          }
          resolve()
        }).catch((error) => {
          this.$toast.clear()
          reject(error)
        })
      })
    },
    // 上传图片到服务器
    uploadPhoto (photoFileId) {
      if (!photoFileId) return
      console.log('upload')
      const data = {
        photoFileId: photoFileId,
        templateCode: this.templateCode,
        photoYear: new Date().getFullYear(),
        photoMonth: this.photoMonth
      }
      extraStyleApi.uploadExtraStylePhoto(data).then((response) => {
        if (response.data.resultCode === '0') {
          this.$dialog.alert({
            title: '提示',
            message: '图片上传成功'
          }).then(() => {
            this.$router.push({ name: 'extra-style-center' })
          })
        }
      })
    },
    checkedActivityTime () {
      const currentTime = new Date().getTime()
      const startTime = new Date('2020/02/25 00:00:00').getTime()
      const endTime = new Date('2020/12/14 00:00:00').getTime()
      if (currentTime < startTime) {
        this.$toast({ message: '活动尚未开始' })
        return false
      }
      if (currentTime > endTime) {
        this.$toast({ message: '活动已结束' })
        return false
      }
      if (currentTime < endTime && currentTime > startTime) {
        return true
      }
    }
  }
}
</script>

<style lang="less" scoped>
.image-wrapper {
  width: 100%;
  padding: 10px 0;
  text-align: center;
  .image-uploader-wrapper {
    z-index: 0;
    position: absolute;
    top: 16%;
    left: 0;
    right: 0;
    width: 72%;
    height: 58.5%;
    margin: auto;
  }
}
.confirm-btn {
  padding: 20px 0;
  text-align: center;
  background: url('../../assets/images/extra-style/bg.jpg') no-repeat;
  background-size: 100% 100%;
  img {
    width: 150px;
  }
}
.cropper-content {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
  background-color: #000;
  .cropper {
    padding-top: 5px;
    width: auto;
    height: calc(90vh);
  }
  .cropper-button {
    display: inline-block;
    width: 50%;
    line-height: calc(10vh);
  }
}
</style>
